module.exports = __webpack_public_path__ + "static/media/09_northgate_village-burnaby.90f4a39e.jpg";